import { getTime } from '@yandex-int/k-common/client/api';
import b from 'b_';
import cx from 'classnames';
import { LessonCalendar } from 'education-icons';
import { Datetimepicker, Select, Text } from 'platform-components';
import { SELECT_THEMES } from 'platform-components/constants';
import React from 'react';

import { LESSON_DATES } from 'common.components/constants';

import './lesson-date-select.scss';

interface SelectChangeEvent {
    target: {
        value: LESSON_DATES;
    };
}

export interface Option {
    value: LESSON_DATES;
    label: string;
}

interface OwnProps {
    disabled?: boolean;
    mix?: string;
    options: Option[];
    onChange: (value: LESSON_DATES, customDate: Date | null) => void;
    preventCrossing?: boolean;
    formatDate: (date: Date) => string;
    errorMessage?: React.ReactNode;
    isMobile?: boolean;
    value?: LESSON_DATES;
    customDate?: Date | null;
}

interface Props extends OwnProps {}

class LessonDateSelect extends React.Component<Props> {
    getPickDateLabel = () => {
        const { formatDate, customDate } = this.props;

        const DEFAULT_PLACEHOLDER = (
            <Text id="assignLessonModal.lessonDatePicker.pickDateAndTime" weight={Text.WEIGHT.M} />
        );

        return customDate ? formatDate(customDate) : DEFAULT_PLACEHOLDER;
    };

    getNow = () => {
        return getTime().then((datetime: number) => new Date(datetime));
    };

    handlePickOption = async ({ target: { value } }: SelectChangeEvent) => {
        const { onChange } = this.props;

        onChange(value, null);
    };

    handleDatepickerChange = (date: Date) => {
        const { onChange } = this.props;

        onChange(LESSON_DATES.CUSTOM, date);
    };

    render() {
        const { errorMessage, disabled, options, value, customDate, preventCrossing, mix } = this.props;
        const customDatePicked = Boolean(customDate);

        return (
            <div className={cx('lesson-date-select', mix)}>
                <Select
                    disabled={disabled}
                    focused={false}
                    mix="lesson-date-select__select"
                    onChange={this.handlePickOption}
                    popupMix="lesson-date-select__select-popup"
                    theme={SELECT_THEMES.TEACHER}
                    value={value}
                    width="100%"
                >
                    {options
                        .map((option) => (
                            <Select.Option
                                key={option.value}
                                mix={cx(b('lesson-date-select', 'item'), `qa_lesson-date-type-${option.value}`)}
                                value={option.value}
                            >
                                {option.label}
                            </Select.Option>
                        ))
                        .concat([
                            <Select.Option
                                key={LESSON_DATES.CUSTOM}
                                mix={cx(
                                    b('lesson-date-select', 'item', {
                                        'custom-date': true,
                                        'not-picked': !customDatePicked,
                                    }),
                                    `qa_lesson-date-type-${LESSON_DATES.CUSTOM}`
                                )}
                                value={LESSON_DATES.CUSTOM}
                            >
                                <LessonCalendar className="lesson-date-select__calendar-icon" />
                                {this.getPickDateLabel()}
                            </Select.Option>,
                        ])}
                </Select>
                {!disabled && value === LESSON_DATES.CUSTOM && (
                    <Datetimepicker
                        date={customDate}
                        disabled={disabled}
                        getNow={this.getNow}
                        mix="lesson-date-select__datetimepicker"
                        onChange={this.handleDatepickerChange}
                        preventCrossing={preventCrossing}
                    />
                )}
                <div className="lesson-date-select__error">
                    <Text>{errorMessage}</Text>
                </div>
            </div>
        );
    }
}

export default LessonDateSelect;
